/**
 * Disable ui-sref based on a condition.
 *
 * @usage: <a ui-sref-if="!form.$invalid" ui-sref-route="home">test</a>
 */
export const uiSrefIf = ($compile) => {
  'ngInject';

  return {
    link,
    scope: {
      route: '@uiSrefRoute',
      if: '=uiSrefIf'
    }
  };

  function link($scope, $element, $attrs) {
    $element.removeAttr('ui-sref-if');
    $compile($element)($scope);

    $scope.$watch('if', function (bool) {
      if (bool) {
        $element.attr('ui-sref', $scope.route);
      } else {
        $element.removeAttr('ui-sref');
        $element.removeAttr('href');
      }
      $compile($element)($scope);
    });
  }
};
